export type AdvertiserReportStatus = 'draft' | 'generating' | 'completed' | 'failed'

export type AdvertiserReportRaw = {
  uuid: string
  name: string
  locale: string
  created_by: number
  created_at: string
  pages_count: number
  store_ids: number[]
  default_period_start?: string | null
  default_period_end?: string | null
}

export type AdvertiserReport = {
  uuid: string
  name: string
  locale: string
  createdBy: number
  createdAt: string
  pagesCount: number
  storeIds: number[]
  defaultPeriodStart: string | null
  defaultPeriodEnd: string | null
}

export type AdvertiserReportPageRaw = {
  id: number
  position: number
  status: AdvertiserReportStatus
  input: string
  output: string | null
  input_tokens: number | null
  output_tokens: number | null
  duration: number | null
}

export type AdvertiserReportPage = {
  id: number
  position: number
  status: AdvertiserReportStatus
  input: string
  output: string | null
  inputTokens: number | null
  outputTokens: number | null
  duration: number | null
}

export type AdvertiserReportDetailRaw = {
  uuid: string
  name: string
  locale: string
  created_at: string
  pages: AdvertiserReportPageRaw[]
  default_period_start?: string | null
  default_period_end?: string | null
}

export type AdvertiserReportDetail = {
  uuid: string
  name: string
  locale: string
  createdAt: string
  pages: AdvertiserReportPage[]
  defaultPeriodStart: string | null
  defaultPeriodEnd: string | null
}

export const normalizeAdvertiserReports = (data: AdvertiserReportRaw[]): AdvertiserReport[] =>
  data.map((item) => ({
    uuid: item.uuid,
    name: item.name,
    locale: item.locale,
    createdBy: item.created_by,
    createdAt: item.created_at,
    pagesCount: item.pages_count,
    storeIds: item.store_ids,
    defaultPeriodStart: item.default_period_start ?? null,
    defaultPeriodEnd: item.default_period_end ?? null,
  }))

export const normalizeAdvertiserReportPages = (
  data: AdvertiserReportPageRaw[],
): AdvertiserReportPage[] =>
  data
    .map((item) => ({
      id: item.id,
      position: item.position,
      status: item.status,
      input: item.input,
      output: item.output,
      inputTokens: item.input_tokens,
      outputTokens: item.output_tokens,
      duration: item.duration,
    }))
    .sort((a, b) => a.position - b.position)

export const normalizeAdvertiserReportDetail = (
  data: AdvertiserReportDetailRaw,
): AdvertiserReportDetail => ({
  uuid: data.uuid,
  name: data.name,
  locale: data.locale,
  createdAt: data.created_at,
  pages: normalizeAdvertiserReportPages(data.pages ?? []),
  defaultPeriodStart: data.default_period_start ?? null,
  defaultPeriodEnd: data.default_period_end ?? null,
})
